import React from 'react';
import { HashRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import Invoice from './invoice/invoice';

// components

export default (props) => {
    const routes = [{
        path: '/invoice/:arg1/:arg2',
        Component: Invoice,
    }];

    return (
        <Router>
            <div>
                <Switch>
                    <Redirect from="/" to="/invoice" exact/>
                    {routes.map(({ path, Component }, key) => <Route exact path={path} component={Component} key={key} />)}
                </Switch>
            </div>
        </Router>
    );
};